import React, { useMemo } from 'react';
import classnames from 'classnames';

export const Image = ({ base, src, alt, className }) => {
	// Concat className with modifiers
	const cls = useMemo(() => classnames(
		'image',
		className
	), [className]);

	// Concat image's destination
	const destination = useMemo(() => {
		return base
			? `${process.env.REACT_APP_CDN}/${base}/${src}`
			: `${process.env.REACT_APP_CDN}/${src}`;
	}, [base, src]);

	// Do not render undefined src
	if (!src) return <img alt={alt} className={className} />;

	return <img alt={alt} className={cls} src={destination} />;
};

export const Avatar = ({ src, alt, size, circle, rounded, className }) => {
	// Concat className with modifiers
	const cls = useMemo(() => classnames(
		'imageAvatar',
		!size && 'imageAvatar--md',
		size && `imageAvatar--${size}`,
		circle && 'imageAvatar--circle',
		rounded && 'imageAvatar--rounded',
		className
	), [size, circle, rounded, className]);

	return (
		<div className={cls}>
			<Image base="avatars" src={src} alt={alt} />
		</div>
	);
};
